var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"wider",attrs:{"fill-height":""}},[(_vm.overlay.id)?_c('OverlayComponent',{attrs:{"width":_vm.overlay.width,"height":_vm.overlay.height,"edit":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }